export default __webpack_public_path__ + "static/media/CSRealCase2-en-moblie.cf98dbd8.jpg";